import { Component, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-upload-new-cards',
  templateUrl: './upload-new-cards.component.html',
  styleUrls: ['./upload-new-cards.component.scss']
})
export class UploadNewCardsComponent {
  selectedFile: File | undefined;

  loading: boolean = false;

  doneEvent: EventEmitter<void> = new EventEmitter();

  formGroup = this.fb.group({
    description_column: new UntypedFormControl(),
    article_column: new UntypedFormControl(),
    brand_column: new UntypedFormControl(),
    image_column: new UntypedFormControl(),
    folder_column: new UntypedFormControl()
  });

  get imageControl() {
    return this.formGroup.controls.image_column as UntypedFormControl;
  }

  get articleControl() {
    return this.formGroup.controls.article_column as UntypedFormControl;
  }

  get descriptionControl() {
    return this.formGroup.controls.description_column as UntypedFormControl;
  }

  get brandControl() {
    return this.formGroup.controls.brand_column as UntypedFormControl;
  }

  constructor(private fb: UntypedFormBuilder, private productService: ProductService) {}

  onFileSelected(event: any) {
    this.selectedFile = event.target.files.item(0);
    return;
  }

  async upload() {
    if (!this.selectedFile) return window.alert('Файл не выбран!');
    if (!this.articleControl.value || !this.brandControl.value || !this.descriptionControl.value)
      return window.alert('Не все данные заполнены!');
    this.loading = true;
    try {
      const res = await this.productService
        .uploadNewProducts({
          file: this.selectedFile,
          description_column: this.formGroup.value.description_column,
          brand_column: this.formGroup.value.brand_column,
          article_column: this.formGroup.value.article_column,
          image_column: this.formGroup.value.image_column,
          folder_column: this.formGroup.value.folder_column
        })
        .toPromise();
    } catch (err) {
      this.loading = false;
      this.doneEvent.emit();
      return;
    }
    this.loading = false;
    this.doneEvent.emit();
    return;
  }
}
